import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1976D2', // your custom primary color
        secondary: '#424242', // your custom secondary color
        accent: '#82B1FF', // your custom accent color
        error: '#FF5252', // your custom error color
        info: '#2196F3', // your custom info color
        success: '#4CAF50', // your custom success color
        warning: '#FFC107' // your custom warning color
      },
    },
  },
});
